import React from 'react';
import PersonRounded from '@material-ui/icons/PersonRounded';
import ArrowDropDownRounded from '@material-ui/icons/ArrowDropDownRounded';
import ButtonBase from '@material-ui/core/ButtonBase';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { withResizer, withUser } from '../../../../HoCs';
import Component from '../../../Component';
import styles from './styles';
import AccountDetails from '../AccountDetails';

class Account extends Component {

    state = {
        popperOpen: false,
        popperAnchor: null,
    }

    styles = styles;

    openPopper = e => this.setState({ popperOpen: true, popperAnchor: e.currentTarget });
    closePopper = () => this.setState({
        popperOpen: false, popperAnchor: null
    });

    render = () => <>
        <ButtonBase style={this.gs('container')} onClick={this.openPopper} TouchRippleProps={{ style: { color: 'var(--ripple)' } }}>
            <PersonRounded style={this.gs('person')} />
            <div style={this.gs('name')}>{this.getUserName()}</div>
            <ArrowDropDownRounded style={this.gs('arrow')} />
        </ButtonBase>
        <Popper open={this.state.popperOpen} anchorEl={this.state.popperAnchor} transition style={this.gs('popper')}>
            {({ TransitionProps }) => <ClickAwayListener onClickAway={this.closePopper}>
                <Grow {...TransitionProps} timeout={150} style={{ transformOrigin: '50% 0%' }}>
                    <div style={this.gs('account_details')}><AccountDetails /></div>
                </Grow>
            </ClickAwayListener>}
        </Popper>
    </>;

}

export default withUser(withResizer(Account));